import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'footerMenus';
export const footerMenusActions = makeActions(MODEL_NAME, 'id', 'cms');

export const getAllFooterMenus = footerMenusActions.getAll;
export const editFooterMenus = footerMenusActions.edit;
export const createFooterMenus = footerMenusActions.create;
export const getByIdFooterMenus = footerMenusActions.getDataById;
